import { httpGuest } from '@/lib/httpGuest';
import type { PostOrderInquiryParams, PostOrderInquiryResponse } from '../types';

export const postOrderInquiry = async (params: PostOrderInquiryParams): Promise<PostOrderInquiryResponse> => {
  return await httpGuest<PostOrderInquiryResponse>('/user/v1/gf/order-inquiry', {
    method: 'POST',
    body: JSON.stringify({
      order_id: params.orderId,
      email: params.email,
    }),
  });
};
